<form [formGroup]="modbusSlaveForm">

  <div class="card mb-3">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col">
          <span class="h5 mb-0" [innerText]="formControls.slaveName.value"></span>
        </div>

        <div class="col-auto">
          <button aria-label="remove signal" class="btn btn-sm btn-outline-danger"
            (click)="remove()" title="remove">
            <span class="fa-solid fa-trash" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">

      <div class="row align-items-end">
        <div class="col-12 col-md-6 col-lg-4">
          <div class="form-group mb-0">
            <label translate>Slave name</label>
            <input id="slaveName" name="slaveName" type="text" formControlName="slaveName"
              class="form-control" [ngClass]="{'is-invalid': formControls.slaveName.errors}"
              (focusout)="onUpdateSlaveProperties()">
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4">
            <div class="form-group mb-0">
              <label translate>Device id</label>
              <input id="deviceId" name="deviceId" type="number"
                [min]="DEVICE_ID_MIN" [max]="DEVICE_ID_MAX"
                formControlName="deviceId"
                class="form-control" [ngClass]="{'is-invalid': formControls.deviceId.errors}"
                (focusout)="onUpdateSlaveProperties()">
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <div class="form-group mb-0">
                <label translate>Address read code</label>
                <input id="addressCode" name="addressCode" type="number"
                  [min]="ADDRESS_READ_CODE_MIN" [max]="ADDRESS_READ_CODE_MAX"
                  formControlName="addressCode"
                  class="form-control" [ngClass]="{'is-invalid': formControls.addressCode.errors}"
                  (focusout)="onUpdateSlaveProperties()">
                </div>
              </div>

            </div>

            <hr>

              <div class="row align-items-center mb-2">
                <div class="col">
                  <span class="h5 mb-0" translate>Register</span>
                </div>
                <div class="col-auto">
                  <button aria-label="add register" class="btn btn-primary"
                    (click)="addRegister()" title="Add register">
                    <span class="fa-solid fa-plus" aria-hidden="true"></span>
                    <span translate>Add register</span>
                  </button>
                </div>
              </div>

              @for (register of modbus.registers; track register) {
                <scitis-admin-gateway-modbus-register
                  [register]="register"
                  [signalNames]="signalNames"
                  (registerFormIsValid)="onRegisterFormIsValid($event)"
                  (signalFormIsValid)="onSignalFormIsValid($event)"
                  (removeRegisterChangeEvent)="onRemoveRegister($event)"
                  (removeSignalChangeEvent)="onRemoveSignal($event)">
                </scitis-admin-gateway-modbus-register>
              }
            </div>
          </div>

        </form>